export default __webpack_public_path__ + "static/media/lottery-cat.bb4b00a7.webp";